export default "__VITE_ASSET__vJoWXo7e__"